import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { HeroModule } from 'src/app/shared/components/hero/hero.module';

import {SelfAttendanceProcessingComponent} from './processing.component';
import {InvoiceModule} from '../../shared/components/invoice/invoice.module';

@NgModule({
    imports: [
        CommonModule,
        
        MatButtonModule,
        MatIconModule,
        HeroModule,
        InvoiceModule
    ],
  exports: [
    SelfAttendanceProcessingComponent
  ],
  providers: [
  ],
  declarations: [
    SelfAttendanceProcessingComponent
  ]
})
export class SelfAttendanceProcessingModule { }
